import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Getter, Mutation } from 'vuex-class';

import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkFile from '@/../bower_components/teknisavuecomponents/components/document/TkFile/TkFile.vue';
import TkToolbar from '@/../bower_components/teknisavuecomponents/components/grids/TkToolbar.vue';

import CommonRequests from '@/assets/ts/controller/CommonRequests';
import IndicadoresController from '@/assets/ts/controller/IndicadoresController';
import NovaSolicitacaoController from '@/assets/ts/controller/NovaSolicitacaoController';

import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import Estrutura from '@/../bower_components/teknisavuecomponents/assets/interfaces/Estrutura';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import VueApexCharts from 'vue-apexcharts';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import ToolbarAction from '@/../bower_components/teknisavuecomponents/assets/interfaces/ToolbarAction';

@Component({
  name: 'IndicadoresAfastamentos',
  components: {
    TkFile,
    TkField,
    TkToolbar,
    apexchart: VueApexCharts,
  },
})
class IndicadoresAfastamentos extends Vue {
  // #region [ STORE ]

  private get user(): User {
    return this.$store.getters.user;
  }

  private get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  private get periodoDemonstrativoAtual(): Periodo {
    return this.$store.getters.periodoDemonstrativoAtual;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (string) => void;

  @Mutation('updateEstruturaGerencialAtual')
  private updateEstruturaGerencialAtual: (any) => void;

  private get estruturasGerenciaisStore(): Estrutura[] {
    return this.$store.getters.estruturasGerenciais;
  }

  private chart?: ApexCharts;

    //Afastamentos por CID
  private async getTotalAfastamentosPorCIDLegalOcupacao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAfastamentosPorCIDLegalOcupacao(dtmesCompetenc, dp);
      const qntdAfastamentos: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAfastamentos.push(parseInt(total.QTD_AFASTAMENTOS, 10));
        indicadores.push(total.INDICADOR);
      }
  

      this.seriesPieCidLegalOcup = qntdAfastamentos;
      this.chartOptionsPieCidLegalOcup.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.CidLegalOcup && (this.$refs.CidLegalOcup as any).chart) {
          const chart = (this.$refs.CidLegalOcup as any).chart;
          chart.updateSeries(qntdAfastamentos);
          chart.updateOptions({ labels: indicadores });
        }
       
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Afastamentos por CID(Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  
  private async getTotalAfastamentosPorCIDOcupacao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAfastamentosPorCIDOcupacao(dtmesCompetenc, dp);

      const qntdAfastamentos: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAfastamentos.push(parseInt(total.QTD_AFASTAMENTOS, 10));
        indicadores.push(total.INDICADOR);
      }
     
      this.seriesPieCidOcupacaoGeral = qntdAfastamentos;
      this.chartOptionsPieCidOcupacaoGeral.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.CidOcupGeral && (this.$refs.CidOcupGeral as any).chart) {
          const chart = (this.$refs.CidOcupGeral as any).chart;
          chart.updateSeries(qntdAfastamentos);
          chart.updateOptions({ labels: indicadores });
        }
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Afastamentos por CID (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  //Afastamentos por NTEP
  private async getTotalAfastamentosPorNTEPLegalOcupacao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAfastamentosPorNTEPLegalOcupacao(dtmesCompetenc, dp);

      const qntdAfastamentos: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAfastamentos.push(parseInt(total.QTD_AFASTAMENTOS, 10));
        indicadores.push(total.INDICADOR);
      }

      this.seriesPolorAreaNtepLegalOcup = qntdAfastamentos;
      this.chartOptionsPolorAreaNtepLegalOcup.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.NTEPLegalOcup && (this.$refs.NTEPLegalOcup as any).chart) {
          const chart = (this.$refs.NTEPLegalOcup as any).chart;
          chart.updateSeries(qntdAfastamentos);
          chart.updateOptions({ labels: indicadores });
        }  
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Afastamentos por NTEP (Estrutura Legal x Ocupação)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  private async getTotalAfastamentosPorNTEPOcupacao() {
    try {
      const dtmesCompetenc = DateUtil.getDateCompetenc();
      const dp             = this.user.dp
      const totais = await IndicadoresController.getTotalAfastamentosPorNTEPOcupacao(dtmesCompetenc, dp);
      
      const qntdAfastamentos: number[] = [];
      const indicadores: string[] = [];
      
      for (const total of totais) {
        qntdAfastamentos.push(parseInt(total.QTD_AFASTAMENTOS, 10));
        indicadores.push(total.INDICADOR);
      }

      this.seriesPolorAreaNtepOcupacaoGeral = qntdAfastamentos;
      this.chartOptionsPolorAreaNtepOcupacaoGeral.labels = indicadores;

      this.$nextTick(() => {
        if (this.$refs.NTEPOcupGeral && (this.$refs.NTEPOcupGeral as any).chart) {
          const chart = (this.$refs.NTEPOcupGeral as any).chart;
          chart.updateSeries(qntdAfastamentos);
          chart.updateOptions({ labels: indicadores });
        } 
      });  
    } catch (err) {
      const message = 'Não foi possível carregar o total de Afastamentos por NTEP (Ocupação Geral)!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  // #endregion

  // #region [ DATA ]
  private readonly viewTitle = 'Indicadores de Afastamentos';

  
  // Graficos 
  private seriesPieCidLegalOcup: number[] = [];
  private chartOptionsPieCidLegalOcup = {
    labels: [] as string[],
    title: {
      text: 'Total de afastamentos por CID (Estrutura Legal x Ocupação)',
    },
    chart: {
      type: 'donut',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_afastamentos_cid_legal_ocupacao',
          },
          svg: {
            filename: 'total_afastamentos_cid_legal_ocupacao',
          },
          png: {
            filename: 'total_afastamentos_cid_legal_ocupacao',
          }
        }
      }
    },
  };

  private seriesPieCidOcupacaoGeral: number[] = [];
  private chartOptionsPieCidOcupacaoGeral = {
    labels: [] as string[],
    title: {
      text: 'Total de afastamentos por CID (Ocupação Geral)',
    },
    chart: {
      type: 'donut',
      width: 50,
      height: 50,
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_afastamentos_cid_ocupacao_geral',
          },
          svg: {
            filename: 'total_afastamentos_cid_ocupacao_geral',
          },
          png: {
            filename: 'total_afastamentos_cid_ocupacao_geral',
          }
        }
      }
    },
  };

  private seriesPolorAreaNtepLegalOcup: number[] = [];
  private chartOptionsPolorAreaNtepLegalOcup = {
    chart: {
      type: 'polarArea',
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_afastamentos_ntep_legal_ocupacao',
          },
          svg: {
            filename: 'total_afastamentos_ntep_legal_ocupacao',
          },
          png: {
            filename: 'total_afastamentos_ntep_legal_ocupacao',
          }
        }
      }
    },
    title: {
      text: 'Total de afastamentos por NTEP (Ocupação Geral)',
    },
    labels: [] as string[],
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.8,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  private seriesPolorAreaNtepOcupacaoGeral: number[] = [];
  private chartOptionsPolorAreaNtepOcupacaoGeral = {
    chart: {
      type: 'polarArea',
      toolbar: {
        show: true,
        tools: {
          download: true
        },
        export: {
          csv: {
            filename: 'total_afastamentos_ntep_ocupacao_geral',
          },
          svg: {
            filename: 'total_afastamentos_ntep_ocupacao_geral',
          },
          png: {
            filename: 'total_afastamentos_ntep_ocupacao_geral',
          }
        }
      }
    },
    title: {
      text: 'Total de afastamentos por NTEP (Ocupação Geral)',
    },
    labels: [] as string[],
    stroke: {
      colors: ['#fff'],
    },
    fill: {
      opacity: 0.8,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };

  private loading = false;

  private estruturasGerenciais: any[] = [];
  private estruturasLegais: any[] = [];
  private nrEstrutLegal = '';
  private nrEstrutGeren = '';
  // #endregion

  // #region [ COMPUTED ]
  private get estruturaGerencialField(): Field {
    const descField = 'NMESTRUTURA';
    const field = {
      name: 'NRESTRUTGEREN',
      valueField: 'NRESTRUTURAM',
      descriptionField: descField,
      label: 'Estrutura Gerencial',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasGerenciais,
    };

    return field;
  }

  private get estruturaLegalField(): Field {
    const field: Field = {
      name: 'NRESTRUTLEGAL',
      valueField: 'NRESTRUTURAM',
      descriptionField: 'NRNMESTRUTURA',
      label: 'Estrutura Legal',
      type: 'autocomplete',
      size: 6,
      items: this.estruturasLegais,
    };

    return field;
  }

  private get toolbarActions(): ToolbarAction[] {
    const actions = [
      {
        name: 'reload',
        label: 'Atualizar',
        icon: 'mdi-refresh',
        onClick: this.reload,
        disabled: this.loading,
      },
    ];

    return actions;
  }

  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.viewTitle);
    (window as any).documentos = this;

    this.getTotalAfastamentosPorCIDLegalOcupacao();
    this.getTotalAfastamentosPorCIDOcupacao();
    this.getTotalAfastamentosPorNTEPLegalOcupacao();
    this.getTotalAfastamentosPorNTEPOcupacao();
  }

  private mounted() {
    this.loadEstruturasGerenciais();
    this.loadEstruturasLegais();
  }
  // #endregion

  // #region [ WATCHERS ]
  @Watch('estruturaGerencialAtual')
  private estruturaGerencialAtualOnChange() {
    this.reload();
  }

  @Watch('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtualOnChange() {
    this.reload();
  }
  // #endregion

  // #region [ METHODS ]
  private async reload() {
    if (!this.periodoDemonstrativoAtual || !this.estruturaGerencialAtual) {
      return;
    }

    this.loading = true;

    try {
      await Promise.all([
          this.getTotalAfastamentosPorCIDLegalOcupacao(),
          this.getTotalAfastamentosPorCIDOcupacao(),
          this.getTotalAfastamentosPorNTEPLegalOcupacao(),
          this.getTotalAfastamentosPorNTEPOcupacao(),
      ]);
    } finally {
      this.loading = false;
    }
  }

  private async loadEstruturasGerenciais() {
    let estruturas = [];

    if (this.user.dp) {
      try {
        estruturas = await NovaSolicitacaoController.getEstruturas('GERENCIAL');
      } catch {
        const message = 'Não foi possível carregar as estruturas gerenciais!';
        SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      }
    } else {
      estruturas = this.estruturasGerenciaisStore.filter((estrutura) => {
        const isGerencial = estrutura.IDTIPOESTRUTURA === 'GERENCIAL';
        return isGerencial;
      });
    }

    this.estruturasGerenciais = estruturas;
  }

  private async loadEstruturasLegais() {
    try {
      const estruturas = await NovaSolicitacaoController.getEstruturas('LEGAL');
      this.estruturasLegais = estruturas;
    } catch (err) {
      const message = 'Não foi possível carregar as estruturas legais!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }
  // #endregion
}

export default IndicadoresAfastamentos;